module.exports = __webpack_public_path__ + "img/banner-index-text-s.84d96ebb.jpg";